import Page from '@/components/common/page';
import phoneMasks from './phone-masks.json';
import 'inputmask-multi';
import 'inputmask/dist/jquery.inputmask.bundle';

let editUri = false;
let companyName = '';
let companyUri = '';
let timeout = null;
let maxHostLength = 63;

function RegexString(word) {
    return word.toLowerCase().replace(/[?!.,">':\\«_+`»@#\-(){} \[\];*^=$~№%§]/gi, '')
}

function RegexStringEn(word) {
    return word.toLowerCase().replace(/[?!.,"><₽€£•'’”:\\«&|/_+`»@#\-(){} \[\];*^=$~№%а-яЁё]/gi, '');
}

function TranslateFromRu(word) {
    let newWord = RegexString(word)
    let answer = '';
    let converter = {
        'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd',
        'е': 'e', 'ё': 'e', 'ж': 'zh', 'з': 'z', 'и': 'i',
        'й': 'y', 'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n',
        'о': 'o', 'п': 'p', 'р': 'r', 'с': 's', 'т': 't',
        'у': 'u', 'ф': 'f', 'х': 'h', 'ц': 'c', 'ч': 'ch',
        'ш': 'sh', 'щ': 'sch', 'ь': '', 'ы': 'y', 'ъ': '',
        'э': 'e', 'ю': 'yu', 'я': 'ya',
        'А': 'A', 'Б': 'B', 'В': 'V', 'Г': 'G', 'Д': 'D',
        'Е': 'E', 'Ё': 'E', 'Ж': 'Zh', 'З': 'Z', 'И': 'I',
        'Й': 'Y', 'К': 'K', 'Л': 'L', 'М': 'M', 'Н': 'N',
        'О': 'O', 'П': 'P', 'Р': 'R', 'С': 'S', 'Т': 'T',
        'У': 'U', 'Ф': 'F', 'Х': 'H', 'Ц': 'C', 'Ч': 'Ch',
        'Ш': 'Sh', 'Щ': 'Sch', 'Ь': '', 'Ы': 'Y', 'Ъ': '',
        'Э': 'E', 'Ю': 'Yu', 'Я': 'Ya'
    };

    for (let i = 0; i < newWord.length; ++i) {
        if (converter[newWord[i]] || converter[newWord[i]] == '') {
            answer += converter[newWord[i]];
        } else {
            answer += newWord[i];
        }
    }

    return answer;
}

function UriFromCompanyName(val) {
    let translate = TranslateFromRu(val)
    return translate.substring(0, 63)
}

function CheckNameUri(sendData) {
    let hostGroup = document.querySelector('.field-registerform-host_name');
    let hostInput = hostGroup.querySelector('.register-form__field-host');
    let errorBlock = hostGroup.querySelector('.register-form__errors');
    let secondaryErrorBlock = errorBlock.querySelector('.register-form__errors-host');

    // очищаем предыдущие ошибки
    hostInput.classList.toggle('register-form__field_error', false);
    secondaryErrorBlock.classList.toggle('register-form__errors-host--hidden', true);

    if (sendData) {
        let spinner = document.createElement('span');
        spinner.classList.add('register-form__spinner');
        spinner.style.zIndex = '9999';
        hostGroup.append(spinner);

        $.post("/check-instance", {"host": sendData})
            .done(function (result) {
                hostGroup.querySelector('.register-form__spinner').remove();

                if (!!result) {
                    hostInput.classList.add('register-form__field_error');
                    secondaryErrorBlock.classList.toggle('register-form__errors-host--hidden', false);
                }
            })
            .fail(function (xhr, status, error) {
                hostGroup.querySelector('.register-form__spinner').remove();

                hostInput.classList.add('register-form__field_error');
            });
    }
}

function toggleInputLabel(group, input) {
    const label = group.querySelector('.register-form__label');

    let domain;

    if (group.classList.contains('field-registerform-host_name')) {
        domain = group.querySelector('.register-form__field-domain');
    }

    let isFieldPhone = group.classList.contains('field-registerform-phone');

    if (input.value) {
        label.classList.remove('register-form__label_hidden');
        input.classList.remove('register-form__field_empty');
        if (!!domain) {
            domain.classList.remove('register-form__field-domain--empty');
        }
    } else if (!isFieldPhone) {
        // если поле пустое и это не поле про номер телефона
        label.classList.add('register-form__label_hidden');
        input.classList.add('register-form__field_empty');
        if (!!domain) {
            domain.classList.add('register-form__field-domain--empty');
        }
    } else {
        // если поле для телефона пустое
        label.classList.toggle('register-form__label_hidden', false);
        input.classList.toggle('register-form__field_empty', false);
    }
}

function clearInputError(group, input) {
    const errors = group.querySelectorAll('.register-form__error');

    errors.forEach((error) => {
        if (!error.classList.contains('register-form__errors-host')) {
            // если нет класса register-form__errors-host - тогда удаляем
            error.remove();
        } else {
            // если есть класс register-form__errors-host - не удаляем, скрываем
            error.classList.toggle('register-form__errors-host--hidden')
        }
    })

    input.classList.toggle('register-form__field_error', false);
}

// возвращает длину текста
function getWidthOfText (txt, fontName, fontSize) {
    let el = document.createElement('span');
    el.style.fontSize = fontSize;
    el.style.fontFamily = fontName;
    el.innerHTML = txt;
    document.body.appendChild(el);
    let result = el.offsetWidth;
    document.body.removeChild(el);
    return result;
}

// изменяем видимую ширину домена так, чтобы он не выходил за пределы поля
function clipDomain (domain, possibleDomainLength) {
    domain.style.width = possibleDomainLength + 'px';
}

// перемещаем домен
function moveDomain (companyUriLength) {
    const elemDomain = document.querySelector('.register-form__field-domain');
    elemDomain.style.marginLeft = companyUriLength + 'px';
}

// добавляем в поле с хостом домен
function addDomainToInput (host) {
    // 1) измеряем длину хоста
    let hostLength = getWidthOfText(host, 'Gilroy', '16px' );

    // 2) измеряем длину поля
   const hostInputLength = document.querySelector('.register-form__field-host').offsetWidth - document.querySelector('.register-form__hint-wrapper').offsetWidth;

    // 3) измеряем длину домена
    const domainLength = getWidthOfText (document.querySelector('.register-form__field-domain').innerText , 'Gilroy', '16px');

    // 4) сравниваем длины и смотрим как можем добавить домен в поле
    if (hostLength + domainLength <= hostInputLength) {
        // если надо - изменяем ширину видимого домена
        clipDomain(document.querySelector('.register-form__field-domain'), hostInputLength - hostLength)

        //сдвигаем домен на длину названия компании
        moveDomain(hostLength)
    } else if (hostLength < hostInputLength) {
        // если надо - изменяем ширину видимого домена
        clipDomain(document.querySelector('.register-form__field-domain'), hostInputLength - hostLength)

        //сдвигаем домен на длину названия компании
        moveDomain(hostLength)
    } else if (hostLength > hostInputLength) {
        // если был вставлен текст больше ширины поля - скрываем видимость домена
        document.querySelector('.register-form__field-domain').classList.toggle('register-form__field-domain--empty', true);
    }
}

class RegisterPage extends Page {
    init() {
        this.initPhoneMask();
        this.goBack();
        this.initHostDomain();
        this.initFields();

        $('.register-form__field').on('keyup', this.onChangeInput);
        $('.register-form__field').on('focus', this.inputInFocus);
        $('.register-form__field').on('blur', this.inputOutFocus);
        $('.register-form__field-company').on('change keyup paste', this.changeInputCompanyName)
        $('.register-form__field-host').on('change keyup paste', this.changeInputHost);

        let hintWrapper = document.querySelector('.register-form__hint-wrapper');
        if (hintWrapper) {
            hintWrapper.addEventListener('mouseover', this.showPopup);
            hintWrapper.addEventListener('mouseout', this.showPopup);
        }

        let checkboxInput = document.querySelector('.register-form__checkbox-input');
        if (checkboxInput) {
            checkboxInput.addEventListener('change', this.changeCheckbox);
        }
    }

    changeInputCompanyName(e) {
        let val = e.target.value
        companyName = val

        if (!editUri) {
            const targetGroup = e.target.parentElement;
            const hostGroup = targetGroup.nextElementSibling;
            const hostInput = hostGroup.querySelector('.register-form__field');
            const hostErrors = hostGroup.querySelector('.register-form__errors');
            const hostError = hostErrors.querySelector('.register-form__errors-host');

            // запускаем очистку ошибок
            clearInputError(hostGroup, hostInput);
            hostError.classList.toggle('register-form__errors-host--hidden', true);

            companyUri = UriFromCompanyName(val).substring(0, maxHostLength);

            const group = document.querySelector('.field-registerform-host_name');
            let inputHost = document.querySelector('.register-form__field-host');

            // если в поле company есть новое значение
            if (!!companyUri) {

                inputHost.value = companyUri;

                // перерассчитываем состояние label (виден он или нет)
                toggleInputLabel(group, inputHost);

                // размещаем название домена в поле с хостом
                addDomainToInput(companyUri)

                if (timeout) {
                    clearTimeout(timeout);
                    timeout = null;
                }

                timeout = setTimeout(() => CheckNameUri(companyUri), 1500);
            } else {
                inputHost.value = '';
                clearInputError(hostGroup, hostInput);
                hostError.classList.toggle('register-form__errors-host--hidden', true);

                // перерассчитываем состояние label (виден он или нет)
                toggleInputLabel(group, inputHost);
            }
        }
    }

    showPopup () {
        document.querySelector('.hint').classList.toggle('latest-popup--hidden');
    }

    changeCheckbox (e) {
        const group = e.target.parentElement;
        const input = e.target;

        clearInputError(group, input);
    }

    toggleTooltip() {
        $('.register-form__tooltip').toggleClass('register-form__tooltip_hidden');
    }

    // при попадании пустого поля в фокус, поднимаем label и придаем текстовому полю нужные характеристики
    inputInFocus (e) {
        const group = e.target.parentElement;
        const input = e.target;

        group.querySelector('.register-form__label').classList.toggle('register-form__label_hidden', false);
        group.querySelector('.register-form__field').classList.toggle('register-form__field_empty', false);
    }

    // когда с поля смещается фокус, оцениваем пустое оно или нет и подправляем соотв.классы
    inputOutFocus (e) {
        const group = e.target.parentElement;
        const input = e.target;

        toggleInputLabel(group, input);
    }

    onChangeInput(e) {
        const group = e.target.parentElement;
        const input = e.target;

        toggleInputLabel(group, input);
        clearInputError(group, input);
    }

    changeInputHost(e) {
        const hostGroup = document.querySelector('.field-registerform-host_name');
        const hostInput = hostGroup.querySelector('.register-form__field-host');
        const hostError = hostGroup.querySelector('.register-form__error');

        // убираем предыдущие ошибки у поля
        clearInputError(hostGroup, hostInput);
        hostError.classList.toggle('register-form__errors-host--hidden', true);

        if (!!e.target.value && !!RegexStringEn(e.target.value)) {
            editUri = true;

            // 1) убираем все недопустимые символы в строке
            let val = RegexStringEn(e.target.value);

            // 2) проверяем кол-во символов (при необходимости, обрезаем значение до максимально возвожного кол-ва символов)
            if (val.length > maxHostLength) {
                val = val.substring(0, maxHostLength)
            }

            // 3) присваиваем полученный результат как значение поля хост
            hostInput.value = val

            // 4) размещаем название домена в поле с хостом
            addDomainToInput(val)

            if (timeout) {
                clearTimeout(timeout);
                timeout = null
            }

            timeout = setTimeout(() => CheckNameUri(val), 1500)
        } else {
            editUri = false;
            hostInput.value = null;

            toggleInputLabel(document.querySelector('.field-registerform-host_name'),
                document.querySelector('.register-form__field-host'));

            clearInputError(hostGroup, hostInput);

            hostError.classList.toggle('register-form__errors-host--hidden', true);
        }
    }

    goBack() {
        $('.register__link-go-back').on('click', function (e) {
            e.preventDefault()

            if (document.referrer == "") {
                window.location.replace('/')
            } else {
                window.history.back()
            }
        })
    }

    initPhoneMask () {
        const masksList = $.masksSort(phoneMasks, ['#'], /[0-9]|#/, 'mask');

        $('.register-form__field-phone').inputmasks($.extend(true, {}, {
            inputmask: {
                definitions: {
                    '#': {
                        validator: "[0-9]",
                        cardinality: 1
                    }
                },
                autoUnmask: false,
                clearMaskOnLostFocus: false
            },
            match: /[0-9]/,
            replace: '#',
            listKey: "mask"
        }, {list: masksList})).on('paste', function (e) {
            e.preventDefault();
            if (window.clipboardData) {
                let content = window.clipboardData.getData('Text');
                if (window.getSelection) {
                    let selObj = window.getSelection();
                    let selRange = selObj.getRangeAt(0);
                    selRange.deleteContents();
                    selRange.insertNode(document.createTextNode(content));
                }
            } else if (e.originalEvent.clipboardData) {
                $(this).val((e.originalEvent || e).clipboardData.getData('text/plain'));
            }
            return false;
        });
    }

    initHostDomain () {
        let hostGroup = document.querySelector('.register-form__group--host');

        if (hostGroup) {
            let hostLabel = hostGroup.querySelector('.register-form__label');
            let hostInput = hostGroup.querySelector('.register-form__field-host');
            let domain = hostGroup.querySelector('.register-form__field-domain');

            if (!!hostInput.value) {
                // размещаем название домена в поле с хостом
                addDomainToInput(hostInput.value)

                hostLabel.classList.remove('register-form__label_hidden');
                hostInput.classList.remove('register-form__field_empty');
                domain.classList.remove('register-form__field-domain--empty');
            }
        }
    }

    initFields () {
        let groups = document.querySelectorAll('.register-form__group');

        groups.forEach((group) => {
            let field = group.querySelector('.register-form__field');

            if (field && !!field.value) {
                group.querySelector('.register-form__label').classList.toggle('register-form__label_hidden', false);
                field.classList.toggle('register-form__field_empty', false);
            }
        })
    }
}

export default RegisterPage;
